<template>
  <ul v-if="!isMobile" class="mx-10 grid grid-cols-2 gap-x-2.5 gap-y-5">
    <li
      v-for="card in props.links.slice(0, 4)"
      :key="card.url"
      class="flex cursor-pointer flex-col gap-2.5 text-left"
      role="link"
      @click="handleClick(card.url)"
    >
      <img
        :src="card.image_src"
        :alt="card.image_alt"
        class="aspect-8/10 size-full rounded-2xl object-cover"
      />
      <p class="line-clamp-2 h-12 px-1 text-xs/5 select-none" v-text="card.text" />
    </li>
  </ul>
  <div v-else class="absolute bottom-8 left-0 w-full">
    <div class="swiper empty-cart-carousel">
      <div class="swiper-wrapper">
        <div
          v-for="slide in props.links"
          :key="slide.url"
          class="swiper-slide !flex cursor-pointer flex-col gap-2.5 text-left"
          role="link"
          @click="handleClick(slide.url)"
        >
          <img
            :src="slide.image_src"
            :alt="slide.image_alt"
            class="aspect-8/10 size-full rounded-2xl object-cover"
          />
          <p
            v-if="slide.text"
            class="line-clamp-2 h-10 px-1 text-xs/5 select-none"
            v-text="slide.text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Swiper from 'swiper';
import { onMounted, onUnmounted, watch } from 'vue';

import { useViewportSize } from '../composables/use-viewport-size';

const props = defineProps({
  handleClick: {
    default: () => () => {},
    type: Function,
  },
  links: {
    default: () => [],
    type: Array,
  },
});

let carousel = null;
const { isMobile } = useViewportSize();

const initCarousel = () => {
  carousel = new Swiper('.empty-cart-carousel', {
    slidesOffsetAfter: 18,
    slidesOffsetBefore: 18,
    slidesPerView: 2.4,
    spaceBetween: 10,
  });
};

const destroyCarousel = () => {
  carousel?.destroy();
  carousel = null;
};

onMounted(async () => {
  isMobile.value && initCarousel();
});

onUnmounted(() => {
  carousel && destroyCarousel();
});

watch(
  isMobile,
  () => {
    carousel && destroyCarousel();
    isMobile.value && initCarousel();
  },
  {
    flush: 'post',
  },
);
</script>
